import lazyWithPreload from 'config/lazy-with-preloading';
import AuthGuard from 'modules/shared/components/AuthGuard/AuthGuard';
import { useEffect } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';

const Billing = lazyWithPreload(() => import('./pages/Billing/Billing'));
const InvoiceDetail = lazyWithPreload(() => import('./pages/InvoiceDetail/InvoiceDetail'));

const BillingRouter = () => {
    useEffect(() => {
        Billing.preload();
        InvoiceDetail.preload();
    }, []);

    const routes = useRoutes([
        {
            path: '/',
            element: (
                <AuthGuard hasPermissions={['account']}>
                    <Billing />
                </AuthGuard>
            ),
        },
        {
            path: 'invoices/:date',
            element: (
                <AuthGuard hasPermissions={['account']}>
                    <InvoiceDetail />
                </AuthGuard>
            ),
        },
        {
            path: '*',
            element: <Navigate replace to="/404" />,
        },
    ]);

    return routes;
};

export default BillingRouter;
